import React from "react";
import MainLayout from "../../layouts/MainLayout";
import { Helmet } from "react-helmet-async";

const About = () => {
  return (
    <MainLayout>
      {/* Set SEO Metadata and Canonical Tag */}
        <Helmet>
          <title>About | paralegal.lk</title>
          <meta
            name="description"
            content="paralegal.k is a seach engine for Sri Lankan law. We cover Supreme Court, Court of Appeal, and Provincial High Court decisions as well as reported SLR and NLR reported judgments starting from 1880."
          />
          <link rel="canonical" href="https://www.paralegal.lk/about" />
        </Helmet>

      <div className="flex flex-col justify-center mx-auto max-w-6xl mt-50 p-20 text-pl_txt_light_4 dark:text-pl_txt_dark_2">
        <h1 className="mb-4 font-semibold text-18 md:text-22">
          About{" "}
          <a
            href="https://www.paralegal.lk"
            className="font-bold bg-gradient-to-br from-[#dd0c7e] via-[#ca1582] to-[#a6208e] text-transparent bg-clip-text"
          >
            paralegal.lk
          </a>
        </h1>
        <p className="leading-relaxed mb-4">
          <a
            href="https://www.paralegal.lk"
            className="font-bold bg-gradient-to-br from-[#dd0c7e] via-[#ca1582] to-[#a6208e] text-transparent bg-clip-text"
          >
            paralegal.lk
          </a>{" "}
          is a comprehensive online platform dedicated to providing access to
          Sri Lankan legal resources. We specialize in case law research,
          offering over{" "}
          <span className="font-medium">20,000 appellate court decisions</span>{" "}
          dating back to <span className="font-medium">1880</span>, ensuring
          users can find relevant legal precedents efficiently.
        </p>
        <p className="leading-relaxed mb-4">
          Our advanced search features, including{" "}
          <span className="font-medium">Exact Search</span>,{" "}
          <span className="font-medium">AI Search</span>, and{" "}
          <span className="font-medium">Case Number Search</span>, facilitate
          quick and accurate retrieval of legal information.
        </p>
        <p className="leading-relaxed">
          We aim to support both legal professionals and the public by
          delivering current and relevant legal insights, enhancing
          understanding of Sri Lankan law.
        </p>
        <p className="leading-relaxed mt-4">
          For inquiries, please contact us at{" "}
          <a
            href="mailto:admin@paralegal.lk"
            className="hover:underline text-pl_prim_color_1"
          >
            admin@paralegal.lk
          </a>
        </p>
      </div>
    </MainLayout>
  );
};

export default About;
